"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditorialCarousel = void 0;
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _ArticleBox = require("../ArticleBox");
var _Carousel = require("../Carousel");
var _EditorialCarouselSlide = require("./EditorialCarouselSlide");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const EditorialCarousel = ({
  data,
  autoplay,
  className,
  id,
  navigation,
  pagination,
  propagateDragEvent,
  showPlaceholderIfEmpty = true,
  slider,
  testId,
  width,
  labelRead,
  labelWatch,
  slideMinWidth
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isMobile = (0, _presentationHooks.useIsMobile)();
  const slideWidth = slideMinWidth ?? (isMobile ? _constants.EDITORIAL_CAROUSEL_SLIDE_MOBILE_MIN_WIDTH : _ArticleBox.ARTICLE_BOX_DESKTOP_WIDTH);
  const carousePagination = (0, _react.useMemo)(() => ({
    show: false,
    ...pagination
  }), [pagination]);
  const carouselNavigation = (0, _react.useMemo)(() => ({
    showArrows: !isMobile,
    position: 'outside',
    ...navigation
  }), [isMobile, navigation]);
  const sliderProps = (0, _react.useMemo)(() => ({
    loop: false,
    mode: isMobile ? 'free' : 'snap',
    slides: {
      origin: 'auto',
      perView: 'auto',
      spacing: isMobile ? 15 : 30
    },
    ...slider
  }), [isMobile, slider]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Carousel.Carousel, {
    hasFocusableSlides: true,
    autoplay: autoplay,
    className: className,
    id: id,
    navigation: carouselNavigation,
    pagination: carousePagination,
    propagateDragEvent: propagateDragEvent,
    showPlaceholderIfEmpty: showPlaceholderIfEmpty,
    slider: sliderProps,
    testId: testId ?? getTestId(_constants.EDITORIAL_CAROUSEL),
    width: width,
    children: data.map(slide => /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditorialCarouselSlide.EditorialCarouselSlide, {
      minWidth: slideWidth,
      data: slide,
      labelRead: labelRead,
      labelWatch: labelWatch
    }, slide.link?.relativeUrl))
  });
};
exports.EditorialCarousel = EditorialCarousel;
//# sourceMappingURL=EditorialCarousel.js.map